import React, { FunctionComponent, useContext } from "react";
import "./AddToHomeScreenIos.less";

import { TranslationsContext } from "../../../contexts/translations-context";
import { getSafeTranslation } from "../../../helpers/localization.helper";
//@ts-ignore
import MoreIcon from "../../../images/more.svg";
//@ts-ignore
import AddIcon from "../../../images/add.svg";

interface AddToHomeScreenIosProps {}

export const AddToHomeScreenIos: FunctionComponent<AddToHomeScreenIosProps> = ({}) => {
	const translations = useContext(TranslationsContext);

	return (
		<div className="add-to-home-screen-ios">
			<div className="add-to-home-screen-ios__icon" dangerouslySetInnerHTML={{ __html: AddIcon }}></div>
			<div className="add-to-home-screen-ios__text-container">
				<div className="add-to-home-screen-ios__description">
					{getSafeTranslation("AddToHomeScreenPopup.description", translations)}
				</div>
				<div className="add-to-home-screen-ios__install">
					{getSafeTranslation("AddToHomeScreenPopup.iosInstallInstructionLabel", translations)
						.split(/(\{.+?\})/g)
						.map(instructionElement => {
							if (instructionElement === "{moreIcon}") {
								return (
									<span
										className="add-to-home-screen-ios__more-icon"
										dangerouslySetInnerHTML={{ __html: MoreIcon }}
									></span>
								);
							} else if (instructionElement === "{addToHomeScreenMenuItemName}") {
								return (
									<span className="add-to-home-screen-ios__menu-item-name">
										{getSafeTranslation("AddToHomeScreenPopup.iosAddToHomeScreenMenuItemName", translations)}
									</span>
								);
							} else {
								return <span>{instructionElement}</span>;
							}
						})}
				</div>
			</div>
		</div>
	);
};
